<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner';

const props = defineProps<ToasterProps>();
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-950 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-gray-500',
        actionButton: 'group-[.toast]:bg-gray-900 group-[.toast]:text-gray-50',
        cancelButton: 'group-[.toast]:bg-gray-100 group-[.toast]:text-gray-500',
      },
    }"
  />
</template>
